enum AssetTypes {
  Video = "Video",
  Survey = "Survey",
  Assessment = "Assessment",
  Pdf = "Pdf",
  EmbeddedVideo = "EmbeddedVideo",
  Link = "Link",
  SCORM = "SCORM",
}
export default AssetTypes;
